<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list') ||
              !hasPermissionToCreateExport
          "
          disableFuzzyMatching
        />
      </report-field>
      <report-field
        :field-name="$tc(reportParameters[0].label, 2)"
        v-if="needsLayerSelection"
      >
        <treeselect
          v-model="reportParameters[0].value"
          :options="layerOptions"
          :multiple="layersFieldIsMultiSelect"
          :disabled="
            !hasPermissionToCreateExport || selectedWorkspace === undefined
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "PhotosReport",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "Layer",
          key: "layers",
          type: "array",
          value: undefined
        }
      ],

      layerOptions: [
        { id: "Pole", label: this.$tc("Pole", 2) },
        { id: "Building", label: this.$tc("Building", 2) }
      ],

      template: null,

      historyFilter: "photos"
    };
  },

  computed: {
    buttonsDisabled() {
      return (
        this.needsLayerSelection &&
        (!this.reportParameters[0].value ||
          this.reportParameters[0].value.length == 0)
      );
    },

    /**
     * Determines if the Layers field should be multi-select or not.
     */
    layersFieldIsMultiSelect() {
      if (!this.template) {
        return false;
      }

      return !this.template.just_select_one;
    },

    needsLayerSelection() {
      if (!this.template) {
        return false;
      }
      return this.template.need_select_objects;
    },

    dataToSend() {
      let dataJSON = {};
      if (this.template) {
        dataJSON = {
          type: this.historyFilter,
          version: this.template.version,
          objects: {
            workspace_uuid: this.selectedWorkspace,
            layers: [this.reportParameters[0].value]
          }
        };
      }

      return dataJSON;
    }
  },

  watch: {
    selectedWorkspace(newValue) {
      this.resetReportParameterValues(this.reportParameters, 0);
    }
  },

  mounted() {
    this.setWorkspaceField();
    this.loadTemplate();
  },

  methods: {
    /**
     * Loads the template for the photos export.
     */
    loadTemplate() {
      this.$store
        .dispatch("GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE", "PhotosReport")
        .then(templates => {
          this.template = templates[0];
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/Photos.vue